import { useLocalSearchParams } from 'expo-router';
import type { StoredOutcome } from 'features/feeBasedInstantTransfer/state/submitOutcomeAtoms';
import { type Atom, useAtomValue } from 'jotai';

export default function useMatchedSubmitOutcome<Content>(
  outcomeAtom: Atom<StoredOutcome<Content> | null>,
) {
  const { outcomeId } = useLocalSearchParams<{ outcomeId?: string }>();
  const storedOutcome = useAtomValue(outcomeAtom);
  return storedOutcome && storedOutcome.outcomeId === outcomeId
    ? storedOutcome
    : undefined;
}
